var React = require('react');

function Wave (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none"},React.createElement("g",{"transform":"translate(1.000000, -596.000000)"},React.createElement("g",{"transform":"translate(-1.000000, 0.000000)"},React.createElement("path",{"d":"M0,637 C0,637 225,596 521,596 C792,596 1123,720 1395,720 C1693,720 1920,596 1920,596 L1920,816 L0,816 L0,637 Z","id":"wave-path"})))));
}

Wave.defaultProps = {"viewBox":"0 0 1920 131","version":"1.1"};

module.exports = Wave;

Wave.default = Wave;
